import { deepClone } from "app/utils";
import { Story } from "chq";

const flattenMultiImageStories = (stories: Story[]): Story[] => {
  const flattenStory = (story: Story): Story[] => {
    const visuals = story.visuals || [];
    if (story.media.mediaType === "image" && visuals.length > 1) return visuals.map(visual => ({ ...story, media: visual }));
    return [story];
  };

  return deepClone(stories).reduce((acc: any[], story) => ([...acc, ...flattenStory(story)]), []);
};

export default flattenMultiImageStories;
